<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <div>
        <b-card
          no-body
          class="p-2"
          style="border-radius: 16px; border: 1px solid #dee3ea"
        >
          <b-row
            ><b-col> <h3>Delivery Preference</h3> </b-col
            ><b-col>
              <router-link to="./basic-info">
                <b-button variant="primary" style="float: right">
                  Back
                </b-button>
              </router-link>
            </b-col></b-row
          >
          <b-row class="px-2 mt-2">
            <b-col
              ><div class="mb-2 p-2">
                <b-row class="px-2">
                  <b-col>
                    <p class="medium-text">Delivery Options</p>
                  </b-col>
                </b-row>
                <b-row class="px-2">
                  <b-col>
                    <b-form-checkbox
                      type="checkbox"
                      size="lg"
                      v-model="pickFromShop"
                      class="mt-1"
                    >
                      <p class="ml-2 small-text">Allow pick up from shop</p>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row class="px-2 mb-5">
                  <b-col>
                    <b-form-checkbox
                      type="checkbox"
                      size="lg"
                      v-model="globalDelivery"
                    >
                      <p class="ml-2 small-text">Allow GLobal Delivery</p>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div class="mb-2 p-2" style="padding: 0; margin: 0">
                <b-row class="px-2">
                  <b-col>
                    <p class="medium-text">Manage Delivery</p>
                  </b-col>
                </b-row>
                <b-row class="px-2">
                  <b-col>
                    <b-form-radio-group
                      id="radio-group-2"
                      @change="selectedDeliveryOnChange()"
                      v-model="selectedDelivery"
                      name="radio-sub-component"
                      class="mt-2"
                    >
                      <b-form-radio value="SELF" name="radio-size" size="lg"
                        ><p class="ml-2 small-text">
                          Manage delivery by myself
                        </p>
                      </b-form-radio>
                      <b-row>
                        <b-col>
                          <b-form-radio
                            value="NIPIGE"
                            name="radio-size"
                            size="lg"
                            class="mt-1"
                          >
                            <p class="ml-2 small-text">Delivery by nipige</p>
                          </b-form-radio>
                        </b-col>
                        <b-col>
                          <div v-if="selectedDelivery == 'NIPIGE'" class="mb-4">
                            <eb-select
                              class="mx-5 dropmargin-0"
                              style="width: 80%"
                              :label="'text'"
                              v-model="nipigeDeliverySelect"
                              placeholder="Select options"
                              :options="nipigeDeliveryOptions"
                              :selected="nipigeDeliverySelect"
                            ></eb-select>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div>
        <b-row class="justify-content-center">
          <b-col md="12">
            <div class="cancelSaveBtn">
              <b-button
                variant="danger"
               @click="cancelProcess"
                >CANCEL
              </b-button>
              <b-button variant="primary" @click="saveDeliveryPref()"
                >UPDATE</b-button
              >
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import loader from "@/components/loader/nipigeloader.vue";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";
import currentUserData from "@/mixins/currentUser";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DeliveryPreference",
  components: {
    ComponentHeader,
    ebSelect,
    loader,
  },
  mixins: [currentUserData],
  data() {
    return {
      loading: false,
      pickFromShop: false,
      globalDelivery: false,
      nipigeDeliverySelect: "",
      nipigeDeliveryOptions: [],
      selectedDelivery: "SELF",
      currentUserData: "",
      pathBasicInfo: false,
      pathMyAccount: false,
    };
  },
  methods: {
    ...mapActions({
      getpartnerlist: "partner/fetchPartnersList",
    }),
    async fetchAllPartnerData() {
      await this.getpartnerlist();
    },
    async setPartnerData() {
      let selectedPartnerData = this.partners.find(
        (el) => this.$route.params.id == el._id
      );
      await this.$store.dispatch(
        "partner/editPartnerData",
        selectedPartnerData
      );
    },
    cancelProcess() {
      if (this.pathBasicInfo) {
        this.$router.push({
          name: "basic-info",
          params: { id: this.partnerAllData._id },
        });
      }
      if (this.pathMyAccount) {
        this.$router.push({
          path: "/myaccount",
        });
      }
    },
    selectedDeliveryOnChange() {
      this.nipigeDeliverySelect = "";
    },
    async extractParentHierarchy(data) {
      try {
        await this.$store.dispatch("partner/getMyParentAction", data);
        let newData = this.$store.getters["partner/getMyParentGatter"];
        if (newData != null) {
          this.nipigeDeliveryOptions.push({
            key: newData?.category,
            text: newData?.category,
            id: newData?._id,
            name: newData?.authentication?.userName,
            phone: newData?.authentication?.phone,
            email: newData?.authentication?.email,
          });
          this.extractParentHierarchy(newData._id);
        } else {
        }
      } catch {}
    },
    getCategory(data) {
      if (data) {
        if (data == "TA") {
          return "TENANT";
        } else {
          return data;
        }
      } else {
        return "";
      }
    },
    async saveDeliveryPref() {
      try {
        let payload = {
          delivery: {
            allowPickupFromShop: this.pickFromShop,
            globalDelivery: this.globalDelivery,
          },
        };

        if (this.selectedDelivery == "SELF") {
          payload.delivery.deliveryMethod = this.selectedDelivery;
          payload.delivery.deliveryOwner = {
            id: this.currentUserData._id,
            category: this.currentUserData.category,
            name: this.currentUserData.userName,
            email: this.currentUserData.email,
            phone: this.currentUserData.phone,
          };

          //
        } else if (this.selectedDelivery == "NIPIGE") {
          payload.delivery.deliveryMethod = this.selectedDelivery;
          payload.delivery.deliveryOwner = {
            id: this.nipigeDeliverySelect.id,
            category: this.nipigeDeliverySelect.key,
            name: this.nipigeDeliverySelect.name,
            email: this.nipigeDeliverySelect.email,
            phone: this.nipigeDeliverySelect.phone,
          };
        }

        let payloadFinal = {
          id: this.currentUserData._id,
          data: payload,
        };

        if (
          payload.delivery.deliveryOwner.id &&
          payload.delivery.deliveryOwner.category
        ) {
          await this.$store
            .dispatch(
              "partner/updatePartnerPaymentPreferencesAction",
              payloadFinal
            )
            .then((res) => {
              this.$swal({
                title: "Success",
                text: "Delivery preferences set successfully!",
                type: "success",
              });
              if (this.pathBasicInfo) {
                this.$router.push({
                  name: "basic-info",
                  params: { id: this.partnerAllData._id },
                });
              }
              if (this.pathMyAccount) {
                this.$router.push({
                  path: "/myaccount",
                });
              }
            })
            .catch((err) => {
              this.$swal({
                title: "Error",
                text: "Can not set delivery preferences",
                type: "error",
              });
            });
        } else {
          this.$swal({
            title: "Error",
            text: "Please fillup required fields.",
            type: "error",
          });
        }
      } catch {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      getPreferences: "partner/getPartnerPaymentPreferencesGetter",
      partnerAllData: "partner/GetPartnerData",
    }),
    partners() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category != "STOCK_POINT") {
            let arrayObj = {
              logo: obj?.organization?.logo,
              _id: obj?._id,
              userName: obj?.authentication?.userName,
              email: obj?.authentication?.email,
              phone: obj?.authentication?.phone,
              type: obj?.category,
              ...obj,
            };
            partnerList.push(arrayObj);
          }
        });
        return partnerList.sort(
          (a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt)
        );
      } else {
        return [];
      }
    },
  },

  async mounted() {
    this.loading = true;
    this.fetchAllPartnerData();
    this.setPartnerData();
    if (this.$route.fullPath == "/myaccount/delivery-preference") {
      this.currentUserData = this.$currentUserData;
      this.pathMyAccount = true;
    } else {
      this.currentUserData = {
        ...this.partnerAllData,
        ...this.partnerAllData?.authentication,
      };
      this.pathBasicInfo = true;
    }
    let tenantDetails = await this.$store.dispatch(
      "tenant/getTenantDetailByID",
      this.currentUserData.tenant
    );

    try {
      this.nipigeDeliveryOptions.push({
        key: "TA",
        text: "TENANT",
        id: this.currentUserData?.tenant,
        name: tenantDetails?.response?.authentication?.userName,
        phone: tenantDetails?.response?.authentication?.phone,
        email: tenantDetails?.response?.authentication?.email,
      });
    } catch {}
    await this.extractParentHierarchy(this.currentUserData._id);

    await this.$store.dispatch(
      "partner/getPartnerPaymentPreferencesAction",
      this.currentUserData._id
    );
    try {
      if (this.getPreferences.preferences) {
        this.pickFromShop = this.getPreferences?.preferences?.delivery
          ?.allowPickupFromShop
          ? this.getPreferences?.preferences?.delivery?.allowPickupFromShop
          : false;
        this.globalDelivery = this.getPreferences?.preferences?.delivery
          ?.globalDelivery
          ? this.getPreferences?.preferences?.delivery?.globalDelivery
          : false;

        this.selectedDelivery = this.getPreferences?.preferences?.delivery
          ?.deliveryMethod
          ? this.getPreferences?.preferences?.delivery?.deliveryMethod
          : "SELF";

        this.nipigeDeliverySelect = {
          id: this.getPreferences?.preferences?.delivery?.deliveryOwner?.id
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.id
            : "",
          key: this.getPreferences?.preferences?.delivery?.deliveryOwner
            ?.category
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner
                ?.category
            : "",
          text: this.getPreferences?.preferences?.delivery?.deliveryOwner
            ?.category
            ? this.getCategory(
                this.getPreferences?.preferences?.delivery?.deliveryOwner
                  ?.category
              )
            : "",
          email: this.getPreferences?.preferences?.delivery?.deliveryOwner
            ?.email
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.email
            : "",
          phone: this.getPreferences?.preferences?.delivery?.deliveryOwner
            ?.phone
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.phone
            : "",
          name: this.getPreferences?.preferences?.delivery?.deliveryOwner?.name
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.name
            : "",
        };
      } else {
      }
    } catch {}
    this.loading = false;
  },
};
</script>
<style>
.top-header {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 0px;
}
.medium-text {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0px;
}
.small-text {
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  /* margin-bottom: 0px; */
}
.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}
.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #000000 solid 2px;
}

.delivery-radio-align {
  font-size: 20px;
  margin-left: 11px;
  margin-top: -2px;
  font-size: 20px;
}
[btn-color="primaryx"] {
  height: 39px;
  width: 120px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  text-align: center;
  border-radius: 0px;
}
</style>
